import * as React from "react"
import { useLocation } from "@reach/router";
import { useUserObjectState, useAuthState } from "@myaccountServices"
import { doRedirect } from "../../utils"

const SaveProperty = props => {
    const { state, services } = useUserObjectState()
    const { state: authState, services: authServices } = useAuthState()
    const isAuthenticated = authServices.isAuthenticated()
    const location = useLocation();
    
    const shareurl = typeof window !== 'undefined' ? window.location.href : ''

    const handleSaveProperty = (params, status, type) => {
        let saveparams = {
            params: params,
            type: type,
            state: status,
        }

        if (!isAuthenticated) {
            // save params to send auth params
            authServices.storeData('auth_params', saveparams);
            authServices.storeData('auth_return', location.href);
            doRedirect(process.env.GATSBY_MYACCOUNT_URL);
        } else {
            services.createUserobject(saveparams)
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Property Save',
          'formType': shareurl,
          'formId': 'Save',
          'formName': 'Save',
          'formLabel': 'Save'
        });    

    }

    const isSaved = (params, type) => {
        if (!isAuthenticated) return false

        if (state?.userObjects)
            return services.isSaved(state.userObjects, params, type)
    }

    let params = {id: props.pid},
        isSavedItem,
        savedClass = "wishlist-icn",
        title = "Save ";

    if (state?.userObjects) {
         isSavedItem = isSaved(params, props.type)
    }

    if(isSavedItem) {
        savedClass = "wishlist-icn saved"
        title = "Saved "
    }

    if (props?.noTitle)
        title = '';

    return (
        <>
            <div className={savedClass} id="property-save" aria-label={title + props.type} title={title + props.type}
                onClick={() => {
                    handleSaveProperty(params, !isSavedItem, props.type)
                }}
            >
                <i className="icon-heart-blue"></i>{title}
            </div>
        </>
    )
}

export default SaveProperty
